//
// Prism JS
//

// Import PrismJS package
import Prism from 'prismjs';

// Import PrismJS extensions
// import 'prismjs/themes/prism.css';
// import 'prismjs/components/prism-scss';

// Import Prism JS
// import 'prismjs/plugins/line-numbers/prism-line-numbers';
// import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

Prism.highlightAll();